// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"c8851a19","451":"5905f305"}[chunkId] + ".chunk.js";
};